/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreApiService } from '../core-api-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FirmwareResponseDto } from '../models/firmware-response-dto';
import { receiveConfig } from '../fn/legacy/receive-config';
import { ReceiveConfig$Params } from '../fn/legacy/receive-config';
import { receiveFirmware } from '../fn/legacy/receive-firmware';
import { ReceiveFirmware$Params } from '../fn/legacy/receive-firmware';
import { receiveFirmwareMetadata } from '../fn/legacy/receive-firmware-metadata';
import { ReceiveFirmwareMetadata$Params } from '../fn/legacy/receive-firmware-metadata';
import { receiveRouterStatus } from '../fn/legacy/receive-router-status';
import { ReceiveRouterStatus$Params } from '../fn/legacy/receive-router-status';
import { RouterStatusDto } from '../models/router-status-dto';

@Injectable({ providedIn: 'root' })
export class LegacyAPI extends CoreApiService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `receiveConfig()` */
  static readonly ReceiveConfigPath = '/api/{vendor}/router/config';

  /**
   * Post a CSR for a certification.
   *
   * Post a CSR for a certification and receive the router configuration.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveConfig$Response(params: ReceiveConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return receiveConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Post a CSR for a certification.
   *
   * Post a CSR for a certification and receive the router configuration.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveConfig(params: ReceiveConfig$Params, context?: HttpContext): Observable<Array<string>> {
    return this.receiveConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `receiveFirmware()` */
  static readonly ReceiveFirmwarePath = '/api/{vendor}/router/firmware';

  /**
   * Get the firmware file.
   *
   * Returns the firmware file as download, type application/octet-stream
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveFirmware()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveFirmware$Response(params: ReceiveFirmware$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return receiveFirmware(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the firmware file.
   *
   * Returns the firmware file as download, type application/octet-stream
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveFirmware$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveFirmware(params: ReceiveFirmware$Params, context?: HttpContext): Observable<Array<string>> {
    return this.receiveFirmware$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `receiveFirmwareMetadata()` */
  static readonly ReceiveFirmwareMetadataPath = '/api/{vendor}/router/firmware';

  /**
   * Post a firmware status.
   *
   * Post a new firmware update status and request the possible firmware update actions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveFirmwareMetadata()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveFirmwareMetadata$Response(params: ReceiveFirmwareMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<FirmwareResponseDto>> {
    return receiveFirmwareMetadata(this.http, this.rootUrl, params, context);
  }

  /**
   * Post a firmware status.
   *
   * Post a new firmware update status and request the possible firmware update actions
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveFirmwareMetadata$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveFirmwareMetadata(params: ReceiveFirmwareMetadata$Params, context?: HttpContext): Observable<FirmwareResponseDto> {
    return this.receiveFirmwareMetadata$Response(params, context).pipe(
      map((r: StrictHttpResponse<FirmwareResponseDto>): FirmwareResponseDto => r.body)
    );
  }

  /** Path part for operation `receiveRouterStatus()` */
  static readonly ReceiveRouterStatusPath = '/api/{vendor}/router/status';

  /**
   * Post a new status.
   *
   * Post a new router status and receive the updated status with actions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveRouterStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveRouterStatus$Response(params: ReceiveRouterStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<RouterStatusDto>> {
    return receiveRouterStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Post a new status.
   *
   * Post a new router status and receive the updated status with actions
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveRouterStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveRouterStatus(params: ReceiveRouterStatus$Params, context?: HttpContext): Observable<RouterStatusDto> {
    return this.receiveRouterStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<RouterStatusDto>): RouterStatusDto => r.body)
    );
  }

}
